

export const frontMatter = {
	sidebar_position: 50
};
export const contentTitle = 'PED';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-features-regions-of-interest-ped-md-3fd.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    annotation: "annotation",
    code: "code",
    em: "em",
    h1: "h1",
    header: "header",
    img: "img",
    math: "math",
    mfrac: "mfrac",
    mi: "mi",
    mo: "mo",
    mrow: "mrow",
    p: "p",
    pre: "pre",
    semantics: "semantics",
    span: "span",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "ped",
        children: "PED"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Diameter of a circle that has the same perimeter as the region of interest."
      })
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.a, {
        href: "https://image-js.github.io/image-js-typescript/classes/Roi.html#ped",
        title: "github.io link",
        children: ["🔎 ROI options and parameters of ", _jsx(_components.code, {
          children: "ped"
        }), " accessor"]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["PED represents a diameter of a circle that has the same perimeter as the particle image.\nSimilarly to ", _jsx(_components.a, {
        href: "/docs/Features/Regions%20of%20interest/EQPC",
        title: "internal link on eqpc",
        children: "EQPC"
      }), " it is used to evaluate ROI's sizes albeit from its perimeter and not surface."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "ROI image",
        src: require("!/opt/buildhome/repo/node_modules/url-loader/dist/cjs.js?limit=10000&name=assets/images/[name]-[contenthash].[ext]&fallback=/opt/buildhome/repo/node_modules/file-loader/dist/cjs.js!./img/roi.svg").default + "",
        width: "400",
        height: "356"
      })
    }), "\n", _jsx(_components.p, {
      children: "The formula is simple:"
    }), "\n", _jsx(_components.span, {
      className: "katex-display",
      children: _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            display: "block",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "P"
                }), _jsx(_components.mi, {
                  children: "E"
                }), _jsx(_components.mi, {
                  children: "D"
                }), _jsx(_components.mo, {
                  children: "="
                }), _jsxs(_components.mfrac, {
                  children: [_jsxs(_components.mrow, {
                    children: [_jsx(_components.mi, {
                      children: "P"
                    }), _jsx(_components.mi, {
                      children: "e"
                    }), _jsx(_components.mi, {
                      children: "r"
                    }), _jsx(_components.mi, {
                      children: "i"
                    }), _jsx(_components.mi, {
                      children: "m"
                    }), _jsx(_components.mi, {
                      children: "e"
                    }), _jsx(_components.mi, {
                      children: "t"
                    }), _jsx(_components.mi, {
                      children: "e"
                    }), _jsx(_components.mi, {
                      children: "r"
                    })]
                  }), _jsx(_components.mi, {
                    children: "π"
                  })]
                }), _jsx(_components.mo, {
                  separator: "true",
                  children: ";"
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "PED = \\frac{Perimeter}{\\pi};"
              })]
            })
          })
        }), _jsxs(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: [_jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.6833em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.05764em"
              },
              children: "PE"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.02778em"
              },
              children: "D"
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            }), _jsx(_components.span, {
              className: "mrel",
              children: "="
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            })]
          }), _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "2.0463em",
                verticalAlign: "-0.686em"
              }
            }), _jsxs(_components.span, {
              className: "mord",
              children: [_jsx(_components.span, {
                className: "mopen nulldelimiter"
              }), _jsx(_components.span, {
                className: "mfrac",
                children: _jsxs(_components.span, {
                  className: "vlist-t vlist-t2",
                  children: [_jsxs(_components.span, {
                    className: "vlist-r",
                    children: [_jsxs(_components.span, {
                      className: "vlist",
                      style: {
                        height: "1.3603em"
                      },
                      children: [_jsxs(_components.span, {
                        style: {
                          top: "-2.314em"
                        },
                        children: [_jsx(_components.span, {
                          className: "pstrut",
                          style: {
                            height: "3em"
                          }
                        }), _jsx(_components.span, {
                          className: "mord",
                          children: _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.03588em"
                            },
                            children: "π"
                          })
                        })]
                      }), _jsxs(_components.span, {
                        style: {
                          top: "-3.23em"
                        },
                        children: [_jsx(_components.span, {
                          className: "pstrut",
                          style: {
                            height: "3em"
                          }
                        }), _jsx(_components.span, {
                          className: "frac-line",
                          style: {
                            borderBottomWidth: "0.04em"
                          }
                        })]
                      }), _jsxs(_components.span, {
                        style: {
                          top: "-3.677em"
                        },
                        children: [_jsx(_components.span, {
                          className: "pstrut",
                          style: {
                            height: "3em"
                          }
                        }), _jsxs(_components.span, {
                          className: "mord",
                          children: [_jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.13889em"
                            },
                            children: "P"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.02778em"
                            },
                            children: "er"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "im"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "e"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "t"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.02778em"
                            },
                            children: "er"
                          })]
                        })]
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-s",
                      children: "​"
                    })]
                  }), _jsx(_components.span, {
                    className: "vlist-r",
                    children: _jsx(_components.span, {
                      className: "vlist",
                      style: {
                        height: "0.686em"
                      },
                      children: _jsx(_components.span, {})
                    })
                  })]
                })
              }), _jsx(_components.span, {
                className: "mclose nulldelimiter"
              })]
            }), _jsx(_components.span, {
              className: "mpunct",
              children: ";"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.p, {
      children: "In ImageJS PED is a ROI class accessor that returns a diameter in pixels:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "const pedResult = roi.ped;\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

